import React from 'react';
import { Badge } from '@fluentui/react-components';
import { Signal, Severity } from '../../data/mockExceptionData';
import styles from './ExceptionWorkspace.module.css';

const severityColor: Record<Severity, string> = {
  low: '#107c10',
  medium: '#f7630c',
  high: '#d13438',
  critical: '#a4262c',
};

interface Props {
  signals: Signal[];
  onCreateCase: (signalId: string) => void;
}

const SignalFeed: React.FC<Props> = ({ signals, onCreateCase }) => (
  <div className={styles.signalSection}>
    <div className={styles.signalSectionTitle}>Live Signals ({signals.length})</div>
    {signals.map(sig => (
      <div key={sig.signal_id} className={styles.signalItem} onClick={() => onCreateCase(sig.signal_id)}>
        <div className={styles.signalDot} style={{ background: severityColor[sig.severity] }} />
        <div className={styles.signalContent}>
          <div className={styles.signalTitle}>{sig.title}</div>
          <div className={styles.signalMeta}>
            <Badge size="small" appearance="outline" color="informative">{sig.workflow_type.replace(/_/g, ' ')}</Badge>
            {' · '}
            {sig.detected_at ? new Date(sig.detected_at).toLocaleTimeString() : ''}
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default SignalFeed;
